var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconPlusCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16 31C7.7 31 1 24.3 1 16S7.7 1 16 1s15 6.7 15 15-6.7 15-15 15m8-16.9h-6.1V8c0-.5-.4-1-1-1H15c-.5 0-1 .4-1 1v6.1H8c-.5 0-1 .4-1 1V17c0 .5.4 1 1 1h6.1v6c0 .6.5 1 1 1H17c.6 0 1-.5 1-1v-6.1h6c.6 0 1-.5 1-1V15c0-.5-.5-.9-1-.9"
})));
export default SvgIconPlusCircle;